import React, { useEffect, useRef, useState } from "react";

import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, useLocation } from "react-router-dom";

import orex from "@/assets/images/svg/orexlogo.svg";
import orexSymbol from "@/assets/images/png/orexSymbol.png";
import GoogleTranslate from "@/components/GoogleTranslate";
import { useAuth } from "@/AuthProvider";
import roles from "@/constant/roles.config";
import { privateRoutePaths } from "@/routes/private.route.config";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { buildPath, setAuthHeaders } from "@/utils/common";
import navArrow from "@/assets/images/png/menu-dd-arrow.png";
import navMegaArrow from "@/assets/images/webp/footer-arrow.webp";
import Loginicon from "@/assets/images/png/login-icon.png";

import BenefitMenu from "@/assets/images/webp/benefits-menu.webp";

import _ from "lodash";
import API_URL from "@/constant/api.config";
import axiosInstance from "@/axiosHttp";

const apiUrl = API_URL;

function Header() {

  const { user, isPreKYCUser, isDemoUser, isEndUser, isViewer } = useAuth();

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const location = useLocation();

  const [isSticky, setIsSticky] = useState(false);

  const marqueeRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 300); // after 50px scroll
      document.body.classList.remove("body--mega-active");
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const handleClick = () => {
    if (window.innerWidth < 1200) {
      setShowOffcanvas(true);
    } else {
      setShowOffcanvas(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1200) {
        // setShowOffcanvas(showOffcanvas);
        setShowOffcanvas(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);



  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  //   let userData = localStorage.getItem("user");
  //   let getRoleData = userData.role_slug;
  //  // let getRoleData = JSON.parse(userData.role_slug);
  //   console.log(getRoleData);

  const handleMouseEnter = () => {
    document.body.classList.add("body--mega-active");
  };

  const handleMouseLeave = () => {
    document.body.classList.remove("body--mega-active");
  };

  const handleMouseOver = (e) => {
    //e.target.stop();
    marqueeRef.current?.stop?.()
  };

  const handleMouseOut = (e) => {
    // e.target.start();
    marqueeRef.current?.start?.()
  };


  const Logout = async (e) => {
    const headers = setAuthHeaders();
    return await axiosInstance
      .post(apiUrl + "/logout", {}, { headers })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status == true) {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            console.log(response.data);
          }
        } else {
          console.log(response);
        }

      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <header className={`${isSticky ? "stickys" : "no-stickys"
        }`}>
        {/* // UP Header wrape START  */}
        <div className="up-header">
          <div className="container">
            <div className="inner-pad">
              <div className="announcement-wrape">
                <span className="text">Announcement :</span>
                <marquee direction="left"
                  ref={marqueeRef}
                  onMouseOver={handleMouseOver}
                  onMouseOut={handleMouseOut}>Discover what’s new - explore more opportunities, connect better and grow with confidence worldwide.</marquee>
              </div>
              <ul className="desktop-translate">
                <li className="translater-wrape">
                  <GoogleTranslate />
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* // UP Header wrape END  */}

        {/* // DOWN Header wrape START  */}
        <div className="down-header">
          <div className="container">
            <div className="brand-wrape">
              <Link to={publicRoutePaths.HOME.path} className="brand" title="">
                <img src={orex} alt="OrexTrade" loading="lazy" width={300} height={100} />
              </Link>
              <Link to={publicRoutePaths.HOME.path} className="brand small" title="">
                <img src={orexSymbol} alt="OrexTrade" loading="lazy" width={51} height={48} />
              </Link>
            </div>
            <div className="right-section">
              <div className="menu-wrape">
                {_.map(["xl"], (expand) => (
                  <Navbar key={expand} expand={expand} className="landing-navbar ">
                    <Container fluid>
                      {/* <img src={orex} alt="" className='logo-small' /> */}



                      <Navbar.Offcanvas
                        show={showOffcanvas}
                        onHide={() => setShowOffcanvas(false)}
                        id={`offcanvasNavbar-expand-${expand}`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                        placement="start"
                      >
                        <Offcanvas.Header closeButton>
                          <Link to={publicRoutePaths.HOME.path} title="Home">
                            <img src={orex} alt="OrexTrade" loading="lazy" width={300} height={100} />
                          </Link>
                          {/*  <Offcanvas.Title
                            id={`offcanvasNavbarLabel-expand-${expand}`}
                          >
                            <h2 className="app-brand-text demo menu-text fw-bold ms-2 ps-1"></h2>
                          </Offcanvas.Title> */}
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                          <ul className="justify-content-start flex-grow-1 nav-menu">
                            <li className="mobile-auth">
                              <div className="other-menu">
                                <Link
                                  className={
                                    location.pathname === publicRoutePaths.JOIN_LOGISTIC.path
                                      ? 'button-wrape active' : 'button-wrape'}
                                  to={publicRoutePaths.JOIN_LOGISTIC.path} title="Join as Logistic Partner">
                                  <span>Join as</span>
                                  Logistics Partner
                                </Link>
                                <Link
                                  className={
                                    location.pathname === publicRoutePaths.BECOME_SUPPLIER.path
                                      ? 'button-wrape active' : 'button-wrape'} to={publicRoutePaths.BECOME_SUPPLIER.path} title="Become Supplier">
                                  <span>Become a</span>
                                  Supplier
                                </Link>
                              </div>
                              {/* <ul className="auth-links">
                                {user ? (
                                  <>
                                    {(() => {
                                      switch (user.role_slug.slug) {
                                        case 'SUP_ADM':
                                          return <Link to={`/${getPrefix()}${privateRoutePaths.MANAGE_LEADS.path}`} className="border-btn btn" title="Dashboard">Dashboard</Link>;
                                        case 'END_USER':
                                          if (user?.company_status == 1) {
                                            return <Link to={`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`} className="border-btn btn" title="Dashboard">Dashboard</Link>;
                                          }
                                          break;
                                        case 'DEMO':
                                          return <Link to={`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`} className="border-btn btn" title="Dashboard">Dashboard</Link>;
                                        case 'VIEWER':
                                          return <Link to={`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`} className="border-btn btn" title="Dashboard">Dashboard</Link>;
                                        case 'PRE_KYC':
                                          return <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`} className="border-btn btn" title="Go to profile">Go to profile</Link>;
                                        default:
                                          break;
                                      }
                                    })()}
                                  </>
                                ) : (
                                  <>
                                    <li>
                                      <Link to={publicRoutePaths.LOGIN.path} className="btn secondry-btn" title="Login">Login</Link>
                                    </li>
                                    <li>
                                      <Link to={publicRoutePaths.REGISTRATION.path} className="btn quaternary-btn" title="Register">Register</Link>
                                    </li>
                                  </>
                                )}
                              </ul> */}
                            </li>
                            {/* <li>
                              <Link
                                className={
                                  location.pathname === "/"
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                to="/"
                                onClick={handleClick}
                              >
                                Home
                              </Link>
                            </li> */}
                            <li>
                              <Link
                                className={
                                  location.pathname === publicRoutePaths.ABOUT_US.path
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                to={publicRoutePaths.ABOUT_US.path}
                                onClick={handleClick}
                                title="About Us"
                              >
                                About Us
                              </Link>
                            </li>
                            <li>
                              <Link
                                className={
                                  location.pathname === publicRoutePaths.OUR_SERVICES.path
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                to={publicRoutePaths.OUR_SERVICES.path}
                                onClick={handleClick}
                                title="Services"
                              >
                                Services
                              </Link>
                            </li>
                            {/* <li>
                              <Link
                                className={
                                  location.pathname === "/our-services"
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                to="/our-services"
                                onClick={handleClick}
                              >
                                Our Services
                              </Link>
                            </li> */}
                            <li className="nav-item"
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}>
                              <Link
                                className={
                                  location.pathname ===
                                    publicRoutePaths.GLOBAL_TRADE_NETWORK.path ||
                                    location.pathname ===
                                    publicRoutePaths.DIGITAL_PROMOTION.path ||
                                    location.pathname === publicRoutePaths.FINANCIAL_PROTECTION.path ||
                                    location.pathname ===
                                    publicRoutePaths.CUSTOMER_SUPPORT.path ||
                                    location.pathname ===
                                    publicRoutePaths.BUSINESS_LEADS.path
                                    ? "nav-link benefit-link active"
                                    : "nav-link benefit-link"
                                }
                                onClick={handleClick}
                                title="Benefits"
                              >
                                Benefits <img src={navArrow} alt="" loading="lazy" width={6} height={12} />
                              </Link>
                              <ul className="mega-menu mobile-mega-menu">
                                <li>
                                  <Link
                                    className={
                                      location.pathname ===
                                        publicRoutePaths.GLOBAL_TRADE_NETWORK.path
                                        ? "nav-link active"
                                        : "nav-link"
                                    }
                                    to={publicRoutePaths.GLOBAL_TRADE_NETWORK.path}
                                    onClick={handleClick}
                                    title="Global Business Network"
                                  >
                                    Global Business Network
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className={
                                      location.pathname ===
                                        publicRoutePaths.DIGITAL_PROMOTION.path
                                        ? "nav-link active"
                                        : "nav-link"
                                    }
                                    to={publicRoutePaths.DIGITAL_PROMOTION.path}
                                    onClick={handleClick}
                                    title="Digital Promotion"
                                  >
                                    Digital Promotion
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className={
                                      location.pathname === publicRoutePaths.FINANCIAL_PROTECTION.path
                                        ? "nav-link active"
                                        : "nav-link"
                                    }
                                    to={publicRoutePaths.FINANCIAL_PROTECTION.path}
                                    onClick={handleClick}
                                    title="Financial Protection"
                                  >
                                    Financial Protection
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className={
                                      location.pathname ===
                                        publicRoutePaths.BUSINESS_LEADS.path
                                        ? "nav-link active"
                                        : "nav-link"
                                    }
                                    to={publicRoutePaths.BUSINESS_LEADS.path}
                                    onClick={handleClick}
                                    title="Quality Business Leads"
                                  >
                                    Quality Business Leads
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className={
                                      location.pathname ===
                                        publicRoutePaths.CUSTOMER_SUPPORT.path
                                        ? "nav-link active"
                                        : "nav-link"
                                    }
                                    to={publicRoutePaths.CUSTOMER_SUPPORT.path}
                                    onClick={handleClick}
                                    title="Customer Support"
                                  >
                                    Customer Support
                                  </Link>
                                </li>

                              </ul>
                            </li>

                            <li>
                              <Link
                                className={
                                  location.pathname === publicRoutePaths.OUR_PRODUCTS.path
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                to={publicRoutePaths.OUR_PRODUCTS.path}
                                onClick={handleClick}
                                title="Our Products"
                              >
                                Our Products
                              </Link>
                            </li>

                            <li>
                              <Link
                                className={
                                  (location.pathname === publicRoutePaths.SUPPLIER_INQUIRY.path || location.pathname === publicRoutePaths.LOGISTIC_INQUIRY.path)
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                onClick={handleClick}
                                title="Inquiry"
                              >
                                Inquiry <img src={navArrow} alt="" loading="lazy" width={6} height={12} />
                              </Link>
                              <div className="ul">
                                <ul>
                                  <li>
                                    <Link
                                      className={
                                        location.pathname ===
                                          publicRoutePaths.SUPPLIER_INQUIRY.path
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to={publicRoutePaths.SUPPLIER_INQUIRY.path}
                                      onClick={handleClick}
                                      title="Supplier"
                                    >
                                      <i className="icon supplier"></i> Supplier
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      className={
                                        location.pathname ===
                                          publicRoutePaths.LOGISTIC_INQUIRY.path
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to={publicRoutePaths.LOGISTIC_INQUIRY.path}
                                      onClick={handleClick}
                                      title="Logistic"
                                    >
                                      <i className="icon logistic"></i> Logistic
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </li>

                            <li>
                              <Link
                                className={
                                  location.pathname === publicRoutePaths.EVENT_HIGHLIGHTS.path
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                onClick={handleClick}
                                title="Events"
                                to={publicRoutePaths.EVENT_HIGHLIGHTS.path}
                              >
                                Events <img src={navArrow} alt="" loading="lazy" width={6} height={12} />
                              </Link>
                              <div className="ul">
                                <ul>
                                  <li>
                                    <Link
                                      className={
                                        location.pathname ===
                                          publicRoutePaths.EVENT_HIGHLIGHTS.path
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to={publicRoutePaths.EVENT_HIGHLIGHTS.path}
                                      onClick={handleClick}
                                      title="Event Gallery"
                                    >
                                      Event Gallery
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      className={
                                        location.pathname ===
                                          "/blogs"
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/blogs"
                                      onClick={handleClick}
                                      title="Blogs"
                                    >
                                      Blogs
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </li>

                            {/* <li>
                              <Link
                                className={
                                  location.pathname === publicRoutePaths.CONTACT_US.path
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                to={publicRoutePaths.CONTACT_US.path}
                                onClick={handleClick}
                                title="Contact Us"
                              >
                                Contact Us
                              </Link>
                            </li> */}
                          </ul>
                          <div className="sticky-footer">
                            <GoogleTranslate />
                          </div>
                        </Offcanvas.Body>
                      </Navbar.Offcanvas>
                    </Container>
                    <Navbar.Toggle
                      aria-controls={`offcanvasNavbar-expand-${expand}`}
                      onClick={() => setShowOffcanvas(!showOffcanvas)}
                    />
                    <div></div>
                  </Navbar>
                ))}

                <div className="other-menu desktop-auth">
                  <Link
                    className={
                      location.pathname === publicRoutePaths.JOIN_LOGISTIC.path
                        ? 'button-wrape active' : 'button-wrape'}
                    to={publicRoutePaths.JOIN_LOGISTIC.path} title="Join as Logistic Partner">
                    <span>Join as</span>
                    Logistics Partner
                  </Link>
                  <Link className={
                    location.pathname === publicRoutePaths.BECOME_SUPPLIER.path
                      ? 'button-wrape active' : 'button-wrape'} to={publicRoutePaths.BECOME_SUPPLIER.path} title="Become Supplier">
                    <span>Become a</span>
                    Supplier
                  </Link>
                </div>
              </div>

              <ul className="auth-links">
                {user ? (
                  <>
                    {(() => {
                      const prefix = `/${getPrefix()}`;
                      switch (user?.role_slug?.slug) {
                        case 'SUP_ADM':
                          return (
                            <>
                              <li>
                                <img src={Loginicon} alt="" loading="lazy" width={24} height={23} />
                                <Link onClick={Logout} title="Logout">Logout</Link>
                              </li>
                              <li>
                                <Link
                                  to={`${prefix}${privateRoutePaths.MANAGE_LEADS.path}`}
                                  className="btn secondry-btn"
                                  title="Dashboard"
                                >
                                  Dashboard
                                </Link>
                              </li>
                            </>
                          );
                          case 'ADMIN':
                          return (
                            <>
                              <li>
                                <img src={Loginicon} alt="" loading="lazy" width={24} height={23} />
                                <Link onClick={Logout} title="Logout">Logout</Link>
                              </li>
                              <li>
                                <Link
                                  to={`${prefix}${privateRoutePaths.MANAGE_LEADS.path}`}
                                  className="btn secondry-btn"
                                  title="Dashboard"
                                >
                                  Dashboard
                                </Link>
                              </li>
                            </>
                          );
                        case 'END_USER':
                          //if (user?.company_status === 1) {
                          return (
                            <>
                              <li>
                                <img src={Loginicon} alt="" loading="lazy" width={24} height={23} />
                                <Link onClick={Logout} title="Logout">Logout</Link>
                              </li>

                              <li>
                                <Link
                                  to={`${prefix}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`}
                                  className="btn secondry-btn"
                                  title="Dashboard"
                                >
                                  Dashboard
                                </Link>
                              </li>
                            </>
                          );
                          //}
                          return null;
                        case 'DEMO':
                          return (
                            <>
                              <li>
                                <img src={Loginicon} alt="" loading="lazy" width={24} height={23} />
                                <Link onClick={Logout} title="Logout">Logout</Link>
                              </li>
                              <li>
                                <Link
                                  to={`${prefix}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`}
                                  className="btn secondry-btn"
                                  title="Dashboard"
                                >
                                  Dashboard
                                </Link>
                              </li>
                            </>
                          );
                        case 'VIEWER':
                          return (
                            <>
                              <li>
                                <img src={Loginicon} alt="" loading="lazy" width={24} height={23} />
                                <Link onClick={Logout} title="Logout">Logout</Link>
                              </li>
                              <li>
                                <Link
                                  to={`${prefix}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`}
                                  className="btn secondry-btn"
                                  title="Dashboard"
                                >
                                  Dashboard
                                </Link>
                              </li>
                            </>
                          );
                        case 'PRE_KYC':
                          return (
                            <>
                              <li>
                                <img src={Loginicon} alt="" loading="lazy" width={24} height={23} />
                                <Link onClick={Logout} title="Logout">Logout</Link>
                              </li>
                              <li>
                                <Link
                                  to={`${prefix}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`}
                                  className="btn secondry-btn"
                                  title="Dashboard"
                                >
                                  Dashboard
                                </Link>
                              </li>
                            </>
                          );
                        case 'OPERATION_USER':
                          return (
                            <>
                              <li>
                                <img src={Loginicon} alt="" loading="lazy" width={24} height={23} />
                                <Link onClick={Logout} title="Logout">Logout</Link>
                              </li>
                              <li>
                                <Link
                                  to={`${prefix}${privateRoutePaths.MANAGE_LEADS.path}`}
                                  className="btn secondry-btn"
                                  title="Dashboard"
                                >
                                  Dashboard
                                </Link>
                              </li>
                            </>
                          );
                        case 'INQ_MANAGER':
                          return (
                            <>
                              <li>
                                <img src={Loginicon} alt="" loading="lazy" width={24} height={23} />
                                <Link onClick={Logout} title="Logout">Logout</Link>
                              </li>
                              <li>
                                <Link
                                  to={`${prefix}${buildPath(privateRoutePaths.ADMIN_INQUIRIES, {
                                    fordate: ""
                                  })}`}
                                  className="btn secondry-btn"
                                  title="Dashboard"
                                >
                                  Dashboard
                                </Link>
                              </li>
                            </>
                          );
                        default:
                          break;
                      }
                    })()}
                  </>
                ) : (
                  <>
                    <li>
                      <Link to={publicRoutePaths.LOGIN.path} className="" title="Login"> <img src={Loginicon} alt="" loading="lazy" width={24} height={23} />  Login</Link>
                    </li>
                    <li>
                      <Link to={publicRoutePaths.REGISTRATION.path} className="register-btn" title="Register">Register</Link>
                    </li>
                  </>
                )}
              </ul>

              {/* <ul className="btn-logis">
                <li className="btn-li">


                  <Link className=" find-btn find-btn-logistic">

                    Search Partners

                  </Link>

                  <ul>

                    <li>

                      {localStorage.getItem("token") === null ? (
                        <Link className="nav-link" to="/find-buyer-supplier">
                          Buyer/Supplier
                        </Link>
                      ) : (
                        <Link className="nav-link" to="/members">
                          Buyer/Supplier
                        </Link>
                      )}

                    </li>

                    <li>
                      <Link className="nav-link" to="/logistic-partner">
                        Logistics
                      </Link>
                    </li>

                  </ul>

                </li>
              </ul> */}

              {/* <div className="right-menu">
                <Link className="button-wrape" to={publicRoutePaths.JOIN_LOGISTIC.path} title="Join as Logistic Partner">
                  <span>Join as</span>
                  Logistics Partner
                </Link>
                <Link className="button-wrape" to={publicRoutePaths.BECOME_SUPPLIER.path} title="Become Supplier">
                  <span>Become a</span>
                  Supplier
                </Link>
              </div> */}
            </div>
            {/* <Link className="find-btn" to="javascript:;">Find Buyer/Supplier</Link> */}
          </div>
        </div>
        {/* // DOWN Header wrape END  */}
      </header>



      <div className="mega-menu-wrape" onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}>
        <div className="inner-pad"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}>
          <div className="mega-menu">
            <div className="container-fluid">
              <div className="row">
                <div className="col-xxl-3 col-xl-3 col-lg-3">
                  <div className="benefit-menu-wrape">
                    <img src={BenefitMenu} alt="" width={480} height={480} />
                  </div>
                </div>

                {/* <ul className="mega-menu">
                  <li>
                    <Link
                      className={
                        location.pathname ===
                          publicRoutePaths.GLOBAL_TRADE_NETWORK.path
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to={publicRoutePaths.GLOBAL_TRADE_NETWORK.path}
                      onClick={handleClick}
                      title="Global Trade Network"
                    >
                      Global Trade Network
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        location.pathname ===
                          publicRoutePaths.DIGITAL_PROMOTION.path
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to={publicRoutePaths.DIGITAL_PROMOTION.path}
                      onClick={handleClick}
                      title="Digital Promotion"
                    >
                      Digital Promotion
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        location.pathname === publicRoutePaths.FINANCIAL_PROTECTION.path
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to={publicRoutePaths.FINANCIAL_PROTECTION.path}
                      onClick={handleClick}
                      title="Financial Protection"
                    >
                      Financial Protection
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        location.pathname ===
                          publicRoutePaths.BUSINESS_LEADS.path
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to={publicRoutePaths.BUSINESS_LEADS.path}
                      onClick={handleClick}
                      title="Quality Business Leads"
                    >
                      Quality Business Leads
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        location.pathname ===
                          publicRoutePaths.CUSTOMER_SUPPORT.path
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to={publicRoutePaths.CUSTOMER_SUPPORT.path}
                      onClick={handleClick}
                      title="Customer Support"
                    >
                      Customer Support
                    </Link>
                  </li>
                </ul> */}
                <div className="col-xxl-9 col-xl-9 col-lg-9 menu-section">
                  <div className="row">
                    <div className="col-xxl-4 col-xl-4 col-lg-6">
                      <Link className={
                        location.pathname ===
                          publicRoutePaths.GLOBAL_TRADE_NETWORK.path
                          ? "nav-link active"
                          : "nav-link"
                      }
                        to={publicRoutePaths.GLOBAL_TRADE_NETWORK.path}
                        onClick={handleClick}
                        title="Global Business Network">
                        <div className="icon-wrape global-trade">

                        </div>
                        <div className="menu-detail">
                          <h3>Global Business Network</h3>
                          <ul>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Verified Global Network
                            </li>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Global Logistics Partners
                            </li>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Market Intelligence
                            </li>
                          </ul>
                        </div>
                      </Link>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-6">
                      <Link
                        className={
                          location.pathname ===
                            publicRoutePaths.DIGITAL_PROMOTION.path
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to={publicRoutePaths.DIGITAL_PROMOTION.path}
                        onClick={handleClick}
                        title="Digital Promotion"
                      >
                        <div className="icon-wrape digital-promotion">

                        </div>
                        <div className="menu-detail">
                          <h3>Digital Promotion</h3>
                          <ul>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Social Media Promotion
                            </li>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Email Marketing Campaigns
                            </li>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Seasonal Promotions
                            </li>
                          </ul>
                        </div>
                      </Link>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-6">
                      <Link
                        className={
                          location.pathname ===
                            publicRoutePaths.CUSTOMER_SUPPORT.path
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to={publicRoutePaths.CUSTOMER_SUPPORT.path}
                        onClick={handleClick}
                        title="Customer Support"
                      >
                        <div className="icon-wrape customer-support">

                        </div>
                        <div className="menu-detail">
                          <h3>Customer Support</h3>
                          <ul>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Dedicated Membership Support
                            </li>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Comprehensive Business Assistance
                            </li>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Global RelationShip Management
                            </li>
                          </ul>
                        </div>
                      </Link>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-6">
                      <Link
                        className={
                          location.pathname === publicRoutePaths.FINANCIAL_PROTECTION.path
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to={publicRoutePaths.FINANCIAL_PROTECTION.path}
                        onClick={handleClick}
                        title="Financial Protection"
                      >
                        <div className="icon-wrape financial-protection">

                        </div>
                        <div className="menu-detail">
                          <h3>Financial Protection</h3>
                          <ul>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Transaction Security
                            </li>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Verified Trade Assurance Network
                            </li>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Membership Benefits & Global Confidence
                            </li>
                          </ul>
                        </div>
                      </Link>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-6">
                      <Link
                        className={
                          location.pathname ===
                            publicRoutePaths.BUSINESS_LEADS.path
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to={publicRoutePaths.BUSINESS_LEADS.path}
                        onClick={handleClick}
                        title="Quality Business Leads"
                      >
                        <div className="icon-wrape quality-business">

                        </div>
                        <div className="menu-detail">
                          <h3>Quality Business Leads</h3>
                          <ul>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Smart Inquiry & Quotation System
                            </li>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Authentic Global Connections
                            </li>
                            <li>
                              <img src={navMegaArrow} alt="" width={14} height={8} /> Easy to Use Member Tool
                            </li>
                          </ul>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </div >

      <div className="menu-overflow" onMouseEnter={handleMouseLeave}
        onMouseLeave={handleMouseEnter}></div>


      {
        showButton && (
          <button onClick={scrollToTop} className="btn back-to-top" type="button" title="Scroll to Up">
            ↑
          </button>
        )
      }
    </>
  );
}

export default Header;

